import { TasksGenerator } from 'components/elearning/tasks/tasks-generator';
import Heading from 'components/universal/heading';
import { useTopic } from 'hooks/useTopic';
import poresImgEn from 'assets/images/elearning/hand-hygiene-and-medical-gloves/en/pores.png';
import pyramid1ImgEn from 'assets/images/elearning/hand-hygiene-and-medical-gloves/en/pyramid1.png';
import pyramid2ImgEn from 'assets/images/elearning/hand-hygiene-and-medical-gloves/en/pyramid2.png';
import pyramid3ImgEn from 'assets/images/elearning/hand-hygiene-and-medical-gloves/en/pyramid3.png';
import poresImg from 'assets/images/elearning/hand-hygiene-and-medical-gloves/pores.png';
import pyramid1Img from 'assets/images/elearning/hand-hygiene-and-medical-gloves/pyramid1.png';
import pyramid2Img from 'assets/images/elearning/hand-hygiene-and-medical-gloves/pyramid2.png';
import pyramid3Img from 'assets/images/elearning/hand-hygiene-and-medical-gloves/pyramid3.png';
import pyramid1ImgOrginal from 'assets/images/elearning/hand-hygiene-and-medical-gloves/pyramid1-orginal.png';
import pyramid2ImgOrginal from 'assets/images/elearning/hand-hygiene-and-medical-gloves/pyramid2-orginal.png';
import pyramid3ImgOrginal from 'assets/images/elearning/hand-hygiene-and-medical-gloves/pyramid3-orginal.png';
import excessiveUseOfGloves from 'assets/images/elearning/hand-hygiene-and-medical-gloves/excessive-use-of-gloves.jpg';
import { Box } from 'components/universal/box';
import { Carousel } from 'components/universal/carousel';
import Paragraph from 'components/universal/paragraph';
import { useTranslation } from 'react-i18next';
import { getMediaLanguage } from 'utils/language';
import cls from './hand-hygiene-and-medical-gloves.module.scss';


export const HandHygieneAndMedicalGloves = () => {
    const { t, i18n } = useTranslation('', {
        keyPrefix:
            'elearning.handHygiene.handDisinfectionAndWashing.handHygieneAndMedicalGloves',
    });
    const { tasks, correctAnswer, isAnswerChecked } = useTopic();

    const PYRAMID_IMGS = {
        PL: [pyramid1Img, pyramid2Img, pyramid3Img, poresImg],
        ENG: [pyramid1ImgEn, pyramid2ImgEn, pyramid3ImgEn, poresImgEn],
    };

    const getImg = (imgIndex: number): string =>
        PYRAMID_IMGS[getMediaLanguage(i18n.language)][imgIndex];

    const carousel1 = [{ thumbnail: getImg(0), original: pyramid1ImgOrginal }];
    const carousel2 = [{ thumbnail: getImg(1), original: pyramid2ImgOrginal }];
    const carousel3 = [{ thumbnail: getImg(2), original: pyramid3ImgOrginal }];

    return (
        <div className='container'>
            <Heading className="mb-5" headingLevel="h1" headingStyle="h2a">
                {t('title1')}
            </Heading>

            <Box className="boxQuestion boxQuestion-with-padding">
                <Paragraph fontWeight={700}>{t('title2')}</Paragraph>
                <div className="space24"></div>
                <Paragraph>{t('desc1')}</Paragraph>
                <div className="space24"></div>
                <div className={cls.carouselWrrper}>
                    <Heading className={cls.carouseHoverLabel} headingLevel="h1" headingStyle="h2a">{t('carouselHoverLabel')}</Heading>
                    <Carousel items={carousel1} showNav={false} showIndex={false} cleanComponent={true} />    
                </div>
                <div className={cls.carouselWrrper}>
                    <Heading className={cls.carouseHoverLabel} headingLevel="h1" headingStyle="h2a">{t('carouselHoverLabel')}</Heading>
                    <Carousel items={carousel2} showNav={false} showIndex={false} cleanComponent={true} />  
                </div>
                <div className={cls.carouselWrrper}>
                    <Heading className={cls.carouseHoverLabel} headingLevel="h1" headingStyle="h2a">{t('carouselHoverLabel')}</Heading>
                    <Carousel items={carousel3} showNav={false} showIndex={false} cleanComponent={true} />
                </div>
            </Box>

            <Box className="boxQuestion boxQuestion-with-padding">
                <Paragraph fontWeight={700}>{t('title4')}</Paragraph>
                <div className="space24"></div>
                <Paragraph>{t('description4')}</Paragraph>
                <div className="space24"></div>
                <Paragraph className={cls.caption}>{t('caption4')}</Paragraph>
                <div className="space24"></div>
                <img src={excessiveUseOfGloves} alt="excessive-use-of-gloves" />
            </Box>
            
            <div className={cls.taskWrapper}>
                <TasksGenerator
                    tasks={tasks}
                    isChecked={isAnswerChecked}
                    correctAnswer={correctAnswer}
                    isQuiz={false}
                    prefix={t('situationLabel')}
                    prescription={t('taskPrescription')}
                />
            </div>
        </div>
    );
};
